import(/* webpackMode: "eager" */ "D:\\GIT\\learn-frontend\\app\\page.tsx")